"use client";

import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function () {
  const stats = [{
    number: "2024",
    label: "FOUNDED"
  }, {
    number: "08",
    label: "CAUSES"
  }, {
    number: "15",
    label: "DROPS"
  }];
  return <section data-section-id="36" id="the-mission-statement" className="dark bg-background text-foreground pt-[200px] pb-[140px] px-6 md:px-10 lg:px-16 overflow-hidden">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {}
          <div className="lg:col-span-4 flex flex-col gap-8">
            <nav aria-label="breadcrumb" className="font-mono text-xs tracking-widest text-muted-foreground uppercase">
              <Link to="/HomePage" className="hover:text-foreground transition-colors">
                HOME
              </Link>
              <span className="mx-2">/</span>
              <Link to="/AboutImpactPage" className="hover:text-foreground transition-colors">
                OUR IMPACT
              </Link>
            </nav>

            <div className="font-mono text-xs tracking-[0.2em] text-primary uppercase">
              
              
            </div>

            <div className="relative w-full max-w-xs aspect-[3/4] overflow-hidden rounded-lg shadow-lg">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717563/img/humanitarian_awareness_hands.webp" alt="Hands holding a seedling representing growth and humanitarian awareness" loading="lazy" decoding="async" className="w-full h-full object-cover grayscale contrast-110" src="https://prime-egret.10web.cloud/wp-content/uploads/2026/06/Website-pic-3.png" src="https://prime-egret.10web.cloud/wp-content/uploads/2026/07/Website-pic-7.png" />
              <div className="absolute inset-0 pointer-events-none opacity-30 mix-blend-overlay" style={{
              backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/></filter><rect width='100%' height='100%' filter='url(%23n)' opacity='0.6'/></svg>\")"
            }} />
            </div>
          </div>

          {}
          <div className="lg:col-span-8 flex flex-col gap-12">
            {}
            <h1 className="font-default font-light leading-[0.9] tracking-tight" style={{
            fontSize: "clamp(4rem, 9vw, 9rem)"
          }}>
              <span className="block">Keeping</span>
              <span className="block italic" style={{
              WebkitTextStroke: "1.5px hsl(118 72% 58%)",
              color: "transparent"
            }}>
                Awareness
              </span>
              <span className="block">Fresh.</span>
            </h1>

            {}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12 max-w-3xl">
              <div className="font-default text-base leading-relaxed text-muted-foreground">
                <p><span className="float-left font-default text-primary mr-3 mt-1 leading-[0.8]" data-ast-id="f:/src/pages/Home/sections/Mission.tsx|sig:oe1g27" data-ast-start="3016" data-ast-end="3272" style={{
                  fontSize: '5rem'
                }}>4</span>EverFresh was created to keep important causes from being forgotten. In a world where attention moves fast, we use awareness, storytelling, and purpose-driven design to keep real issues visible, remembered, and supported.</p>
              </div>
              <div className="font-default text-base leading-relaxed text-muted-foreground space-y-4">
                <p>Through powerful storytelling and limited-edition apparel, 4EverFresh turns important causes into wearable conversations — helping people learn, share, and support issues that deserve to stay visible.</p>
                <p>Every drop represents a cause — created to keep important issues in people’s minds, on their hearts, and part of the conversation.
              </p>
              </div>
            </div>

            {}
            
          </div>
        </div>
      </div>
    </section>;
}